import { combineReducers } from '@reduxjs/toolkit';
import { NameSpace } from '../const';
import { filtersMainVPO } from '../store/filters/filters';
import { columnsVPO } from '../store/columns/columns';
import { currentDateVPO } from '../store/date/date';
import { dataMainVPO } from '../store/data-main/data-main';
import { dataSummaryVPO } from '../store/data-summary/data-summary';
import { dataReportFactoryVPO } from '../store/report-factory/report-factory';
import { filtersDataVPO } from '../store/filtersData/filtersData';
import { formAddActions } from '../store/formAddActions/formAddActions';
import { vpoCombinedActions } from '../store/vpoCombinedActions/vpoCombinedActions';
import { reportsReducer } from '../store/reports/reports';
import { vpoReportCompletedActions } from '../store/vpoReportCompletedActions/vpoReportCompletedActions';
import { settings } from '../store/settings/settings';

export const rootVpo = combineReducers({
  [NameSpace.FiltersMain]: filtersMainVPO.reducer,
  [NameSpace.Columns]: columnsVPO.reducer,
  [NameSpace.Date]: currentDateVPO.reducer,
  [NameSpace.DataMain]: dataMainVPO.reducer,
  [NameSpace.DataSummary]: dataSummaryVPO.reducer,
  [NameSpace.ReportFactory]: dataReportFactoryVPO.reducer,
  [NameSpace.Settings]: settings.reducer,
  filtersData: filtersDataVPO,
  formAddActions: formAddActions,
  vpoCombinedActions: vpoCombinedActions,
  reports: reportsReducer,
  vpoReportCompletedActions: vpoReportCompletedActions,
});
